import firebase from 'firebase/app';
import store from '../store';
import 'firebase/auth';
import 'firebase/firestore';

const configOptions = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGEING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

firebase.initializeApp(configOptions);

firebase.auth().onAuthStateChanged(async (user) => {
  const accessToken = user ? await user.getIdToken() : null;

  await store.dispatch('fetchUser', {
    user,
    accessToken,
  });
});

export default firebase;
